export const SALES_ORDER_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  PARTIAL_PAID: "partial_paid",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export const SALES_ORDER_STATUS_LABEL: Record<string, string> = {
  [SALES_ORDER_STATUS.PENDING]: "Chưa giao hàng",
  [SALES_ORDER_STATUS.CONFIRMED]: "Đã giao hàng, chưa thanh toán",
  [SALES_ORDER_STATUS.PARTIAL_PAID]: "Thanh toán một phần",
  [SALES_ORDER_STATUS.COMPLETED]: "Đã thanh toán đủ",
  [SALES_ORDER_STATUS.CANCELLED]: "Đã hủy",
};

export const SALES_ORDER_STATUS_COLOR: Record<string, string> = {
  [SALES_ORDER_STATUS.PENDING]: "yellow",
  [SALES_ORDER_STATUS.COMPLETED]: "green",
  [SALES_ORDER_STATUS.CANCELLED]: "red",
  [SALES_ORDER_STATUS.PARTIAL_PAID]: "orange",
  [SALES_ORDER_STATUS.CONFIRMED]: "blue",
};

export const SALES_ORDER_EDIT_MODE = "edit-items";

/**
 * Đơn có được sửa hàng hóa không — phải khớp với ràng buộc của API
 * PATCH /sale-order/:id/items.
 *
 * Đơn 0 đồng được xác nhận là chuyển thẳng sang "đã thanh toán đủ" (không có gì
 * để thu), nên nếu chỉ xét trạng thái thì loại đơn này không bao giờ sửa được.
 */
export const canEditSalesOrderItems = (
  status: string,
  totalAmount: number | string,
): boolean =>
  status === SALES_ORDER_STATUS.PENDING ||
  status === SALES_ORDER_STATUS.CONFIRMED ||
  (status === SALES_ORDER_STATUS.COMPLETED && Number(totalAmount) === 0);

export const PRINT_STATUS_LABEL: Record<string, string> = {
  true: "Đã in",
  false: "Chưa in",
};

export const PRINT_STATUS_COLOR: Record<string, string> = {
  true: "green",
  false: "gray",
};

export const PAGE_STYLE = `
  @font-face {
    font-family: 'Roboto';
    src: url('/fonts/Roboto-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: url('/fonts/Roboto-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: url('/fonts/Roboto-Italic.woff') format('woff');
    font-weight: 400;
    font-style: italic;
  }
  @page {
    size: A4;
    margin: 15mm;
  }
  body {
    font-family: 'Roboto', sans-serif;
    font-size: 11pt;
    color: #000;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;
